import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import { STATUS } from "../../utils/dashboardModel";
export default function DashboardStatus({ status }) {
  const value = STATUS[status] || STATUS.unknown;
  return (
    <Chip
      label={value.label}
      size="small"
      sx={{ color: value.color, bgcolor: value.background, fontWeight: 600, borderRadius: 1.5 }}
    />
  );
}
DashboardStatus.propTypes = { status: PropTypes.string };
